import { useEffect, useState, useRef } from 'react';
import { IonIcon } from '@ionic/react';
import { calendarOutline } from 'ionicons/icons';
import './MyDatepicker.css';
import DatePicker, { DateObject } from "react-multi-date-picker";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import "react-multi-date-picker/styles/layouts/mobile.css";
import moment from 'jalali-moment';


interface Props {
    datepickerParentCallback: Function,
    isGregorian: boolean,
    isRange: boolean,
    value: any,
    minDate?: any,
    maxDate?: any,
    multipleIndex?: number
}
const MyDatepicker = (props: Props) => {
    const datePickerRef = useRef() as any;
    const [value, setValue] = useState<any>()
    const [state, setState] = useState({
        calendar: props.isGregorian ? gregorian : persian,
        locale: props.isGregorian ? gregorian_en : persian_fa,
        switchLabel: props.isGregorian ? 'شمسی' : 'میلادی',
        todayLabel: props.isGregorian ? 'Today' : 'امروز',
        fontClass: props.isGregorian ? 'font-tahoma' : '',
        toggle: props.isGregorian ? false : true
    })
    useEffect(() => {
        setValue(props.value);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.value])
    const SwitchCalendar = () => {
        state.toggle ?
            setState({ ...state, calendar: gregorian, locale: gregorian_en, switchLabel: 'شمسی', todayLabel: 'Today', fontClass: 'font-tahoma', toggle: false })
            :
            setState({ ...state, calendar: persian, locale: persian_fa, switchLabel: 'میلادی', todayLabel: 'امروز', fontClass: '', toggle: true });
    }
    const myDatepickerCallback = (v: any, isToday: boolean) => {
        let valueDates = [v?.toDate?.().toString()];
        if (props.isRange && !isToday) {
            valueDates = [v[0]?.toDate?.().toString(), v[1]?.toDate?.().toString()];
        }
        let resultDates = [] as any;
        let resultJalaliDates = [] as any;
        let resultJalaliDatesFormatted = [] as any;
        valueDates.forEach((item) => {
            if (item) {
                let momentDate = moment(Date.parse(item)).format('YYYY-MM-DD');
                resultDates.push(momentDate);
                let momentJalaliDate = moment(Date.parse(item)).locale('fa').format('YYYY-MM-DD');
                resultJalaliDates.push(momentJalaliDate);
                let momentJalaliDateFormatted = moment(Date.parse(item)).locale('fa').format('YYYY/MM/DD');
                resultJalaliDatesFormatted.push(momentJalaliDateFormatted);
            }
        })
        let result = {
            isJalali: state.calendar === persian ? 'true' : 'false',
            dates: resultDates,
            datesJalali: resultJalaliDates,
            datesJalaliFormatted: resultJalaliDatesFormatted,
            multipleIndex: props.multipleIndex
        };
        props.datepickerParentCallback(result);
    }
    const onDateClick = (v: any) => {
        if (props.isRange) {
            datePickerRef.current.openCalendar();
        }
        setValue(v);
        myDatepickerCallback(v, false);
        datePickerRef.current.closeCalendar();
    }
    const onTodayClick = (v: any) => {
        setValue(v);
        myDatepickerCallback(v, true);
        datePickerRef.current.closeCalendar();
        if (props.isRange) {
            datePickerRef.current.openCalendar();
        }
    }
    const onChange = (v: any) => {
        if (props.isRange) {
            setValue(v);
            myDatepickerCallback(v, false);
            datePickerRef.current.closeCalendar();
        }
    }
    return (
        <div className="my-datepicker">
            <DatePicker
                ref={datePickerRef}
                value={props.value ? props.value : value}
                onChange={value => onChange(value)}
                onFocusedDateChange={(dateFocused, dateClicked) => { onDateClick(dateClicked) }}
                calendar={state.calendar}
                locale={state.locale}
                minDate={props.minDate ? props.minDate : new Date()}
                maxDate={props.maxDate}
                className={"rmdp-mobile " + state.fontClass + (props.isRange ? " is-range" : " is-not-range") + (state.calendar === gregorian ? " gregorian" : " jalali")}
                inputMode="none"
                range={props.isRange}
                multiple={false}
                placeholder="انتخاب تاریخ"
            >
                <div className="datepicker-custom-btns">
                    <button type="button" className="datepicker-switch-btn font-iranyekan" onClick={SwitchCalendar}>
                        {state.switchLabel}
                    </button>
                    <button type="button" className="datepicker-today-btn" onClick={() => onTodayClick(new DateObject())}>
                        {state.todayLabel}
                    </button>
                </div>
            </DatePicker>
            <IonIcon icon={calendarOutline} className="datepicker-icon" />
        </div>
    );
};
export default MyDatepicker;